export default {"src":"/_next/static/media/heavyRain.55be93ff.svg","height":161,"width":161};